// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2NKzK","avatar":"index_avatar_1A3j0","textku":"index_textku_2ZVyh","ant-popover":"index_ant-popover_hNOLt"};